'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import HouseLogo from '../HouseLogo';
import cn from './style.module.scss';
export default function HouseRegisterBanner(props: any) {
  const { t } = props;
  return (
    <Stack component="section" className={cn.houseRegisterBanner}>
      <Box className={cn.houseRegisterBannerInner}>
        <Box className={cn.houseRegisterBannerImage}>
          <Mobile>
            <Image
              src={props.beachHouseRegistrationMobileBanner.url}
              alt="House Register Banner - Beach House Registration Mobile Banner"
              width={768}
              height={768}
              unoptimized
              quality={100}
            />
          </Mobile>
          <Desktop>
            <Image
              src={props.beachHouseRegistrationDesktopBanner.url}
              alt="House Register Banner - Beach House Registration Desktop Banner"
              width={768}
              height={768}
              unoptimized
              quality={100}
            />
          </Desktop>
        </Box>
      </Box>
    </Stack>
  );
}
